import {
  RouterLink,
  RouterLinkProps,
} from '@/utilities/redux-first-router.export';
import { ReactNode } from 'react';

export const BaseContentContainer = ({ children }: { children: ReactNode }) => (
  <div className={'grid gap-4 p-x2 bg-surface-3 relative'}>{children}</div>
);

export const ContentContainerWithHover = ({
  children,
}: {
  children: ReactNode;
}) => (
  <div
    className={
      'grid gap-4 p-x2 bg-surface-3 relative min-h-[235px] max-h-[235px] hover:bg-p-grey-10 focus:bg-p-grey-10 transition ease-out duration-300'
    }
  >
    {children}
  </div>
);

export const BaseRouterLinkWithHover = ({
  children,
  to,
  onClick,
}: RouterLinkProps) => (
  <RouterLink
    className={
      'block min-h-[81px] no-underline focus:underline hover:underline decoration-p-white'
    }
    to={to}
    onClick={onClick}
  >
    {children}
  </RouterLink>
);

export const BaseRouterLinkWithExtraHeight = ({
  children,
  to,
  onClick,
}: RouterLinkProps) => (
  <RouterLink
    className="min-h-[104px] no-underline decoration-p-white"
    to={to}
    onClick={onClick}
  >
    {children}
  </RouterLink>
);
